/**
 * Make a deep copy of this object
 * @param obj Object|Array|...
 * @return Object|Array
 */
export function clone(obj) {
  if (obj === null || typeof obj !== 'object')
    return obj;
  
  if (obj instanceof Array) {
    let res = [];
    
    for (let i = 0, len = obj.length; i < len; i++)
      if (obj[i] !== null && typeof obj[i] === 'object')
        res[i] = clone(obj[i]);
      else
        res[i] = obj[i];
    
    return res;
  } else {
    let res = {};
    
    for (let key in obj)
      if (obj[key] !== null && typeof obj[key] === 'object')
        res[key] = clone(obj[key]);
      else
        res[key] = obj[key];
    
    return res;
  }
}

/**
 * Iterate objects & arrays. IE does not support `forEach` for NodeList.
 * @param obj Object|Array|...
 * @param fn function(key|index, value)
 * @return undefined
 */
export function each(obj, fn) {
  if (obj.length !== undefined) {
    for (let i = 0, len = obj.length; i < len; i++)
      fn(i, obj[i]);
  } else {
    for (let key in obj)
      fn(key, obj[key]);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/components/objects.js